import React ,{ useEffect,useState, useRef } from "react";
import { ORG_GET_SUB_SERVICE_LIST, ORG_ADD_SUB_SERVICE } from "../../../../ApiServices/BaseURL";
import { postData,getData } from "../../../../ApiServices/ApiService";
import { useTheme } from "../../../../GlobalContext/GlobalContext";

const useTaskTypeController = (onRefresh,subCategories,loading,error) => {
  const { setIsLoginPopup } = useTheme();
  // const [subCategories, setSubCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [loading, setLoading] = useState(false)
  const [filterError, setFilterError] = useState('');
  const [categorieInfo,setCategorieInfo] = useState({})

  const subCategoryInfoRef = useRef(null);
  const [deleteLoading, setDeleteLoading] = useState({});
  const [deleteError, setDeleteError] = useState({});
  const [deleteSuccess, setDeleteSuccess] = useState({});
  const subCategoryListRef = useRef(subCategories);
  const [subLoading, setSubLoading] = useState(false)
  const [subError, setSubError] = useState(error);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [subCategoriesList, setSubCategoriesList] = useState([]);
  const [serviceErrorMessage, setServiceErrorMessage] = useState('');

  useEffect(()=>{
    // subCategoryInfoRef.current = null;
    //console.log("Sub Categories",subCategories);
    setSubCategoriesList(subCategories);
    // setSubCategoriesList([]);
    // setSubLoading(loading);
  },[subCategories]);


  const fetchTaskSubCategorieList =async (serviceId)=>{
    try {      
      setSubLoading(true);
      setSubError('');
      setServiceErrorMessage('');
     
      // subCategoryListRef.current = [];
      setSubCategoriesList([]);
      setCurrentPage(1);
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    
        // Make the API call service_id=10006&
        const response = await getData(`${ORG_GET_SUB_SERVICE_LIST}?service_id=${serviceId}&emp_id_auth=${storedUserInfo?.emp_id}`);
        const responseData = await response.json();
    
        // Check for success (200) and internal status code
        if (response?.status === 200) {
          if (responseData?.statusCode === 200) {
            if (responseData?.message.toLowerCase() === 'success') {
              if (responseData?.dataJ?.length > 0) {
                // subCategoryListRef.current = responseData?.dataJ
                // subCategoryListRef.current = responseData?.dataJ.map(service => ({
                //   label: service?.service_sub_name,
                //   value: service?.service_sub_id
                // }));
                setSubCategoriesList(responseData?.dataJ);
              } else {
                setSubError(responseData?.info || 'Data Not Found');
              }
            } else {
              setSubError(responseData?.info || 'Failed to fetch data. Please try again.');
            }
          } else {
            setSubError(responseData?.info || 'Something went wrong while processing your request.');
          }
        } 
        // Token-related errors: 400, 401, 403
        else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
          if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
            setSubError('Unauthorized access. Your session may have expired. Please log in again.');
            // Optionally, redirect to the login page or refresh the token
            // Example: redirectToLogin();
          } else {
            setSubError(responseData?.info || 'Bad request. Please check the request parameters.');
          }
          setIsLoginPopup(true)
        } 
        // Internal Server Error: 500
        else if (response?.status === 500) {
          setSubError(responseData?.info || 'Internal Server Error. Please try again later.');
        } 
        // Unexpected or network-related errors
        else {
          setSubError('Unexpected error occurred. Please try again later.');
        }
      } catch (error) {
        // Handle various error scenarios
        if (error.response) {
          // Server responded with a status outside the 2xx range
          setSubError(`Error: ${error.response.status}. ${error.response.data?.message || 'Something went wrong while processing your request. Please try again.'}`);
        } else if (error.request) {
          // Request was made but no response was received
          setSubError('No response received from the server. Please check your network connection and try again.');
        } else {
          // An error occurred in setting up the request
          setSubError(`Something went wrong while processing your request. Please check your network connection and try again.`);
        }
      } finally {
        setSubLoading(false);
      }
  }

  const handleAddCategory = () => {
    subCategoryInfoRef.current = null;
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const getStatusStyle = (status) => {
    switch (status) {
    //   case "2":
    //     return { backgroundColor: "rgba(226, 177, 51, 0.18)", color: "rgba(223, 165, 16, 1)" };
      case 0:
        //Active
        return { backgroundColor: "rgba(238, 32, 28, 0.18)", color: "rgba(238, 32, 28, 1)" };
      case 1:
        //Disabled
        return { backgroundColor: "rgba(26, 147, 46, 0.18)", color: "rgba(26, 147, 46, 1)" };
      default:
        return {};
    }
  };

  const handleEditService =(service)=>{
    setCategorieInfo(service);
    subCategoryInfoRef.current = service;
    setIsModalOpen(true);

  }

  const OnAddUpdateSucess = () => {
    // fetchTaskCategorieList();
    if(onRefresh){
      //console.log('on sub refresh');
      onRefresh();
      setSubError('');
      setFilterError('');
      setServiceErrorMessage('');
      setFilters({
        service: null,
        service_category: null,
      });
      setShowFilters(false);
    }
  }

  const handleDeleteTaskType =  (service) => {
    // //console.log('handleDeleteTaskType service @', service);
    // showConfirmation(service);
    subCategoryInfoRef.current = service;
    // resetFilters();
    // setShowFilters(false);
    setIsDeleteModalOpen(true);
  }

  const showConfirmation = (service) => {
    const confirmed = window.confirm("Are you sure you want to delete?");
    if (confirmed) {
      callDeleteTaskType(service);
    } else {
      //console.log("Delete canceled");
    }
  }

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close the modal
};

  const callDeleteTaskType = async (service) => {
    try {
      setDeleteError({});
      setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: ''}));
      setDeleteLoading((prev) => ({ ...prev, [service?.service_sub_id]: true }));
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "service_sub_id" : service?.service_sub_id,
        "action": "delete_category"
      }
  
      //console.log('callDeleteTaskType payload',payLoad);
  
      // Make the API call
      const response = await postData(ORG_ADD_SUB_SERVICE,payLoad);
      const responseData = await response.json();
      //console.log('callDeleteTaskType response Data',responseData);
  
      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setDeleteSuccess((prev) => ({ ...prev, [service?.service_sub_id]: responseData?.info}));
            setTimeout(() => {
              setDeleteSuccess((prev) => ({ ...prev, [service?.service_sub_id]: ''}));
              OnAddUpdateSucess();
              setCurrentPage(1);
            }, 3000);
          } else {
            setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: responseData?.info || 'Failed to delete service. Please try again.'}));
          }
        } else {
          setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: responseData?.info || 'Failed to delete service. Please try again...'}));
        }
      } 
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: 'Unauthorized access. Your session may have expired. Please log in again.'}));
        } else {
          setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: responseData?.info || 'Bad request. Please check the request parameters.'}));
        }
        setIsLoginPopup(true)
      } 
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: responseData?.info || 'Internal Server Error. Please try again later.'}));
      } 
      // Unexpected or network-related errors
      else {
        setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: 'Unexpected error occurred. Please try again later.'}));
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: `Error: ${error.response.status}. ${error.response.data?.message || 'Failed to delete service. Please try again.'}`}));
      } else if (error.request) {
        setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: 'No response received from the server. Please check your network connection and try again.'}));
      } else {
        setDeleteError((prev) => ({ ...prev, [service?.service_sub_id]: `Failed to delete service data. Please check your network connection and try again.` }));
      }
    } finally {
        setDeleteLoading((prev) => ({ ...prev, [service?.service_sub_id]: false })); 
    }
  }

  const [showFilters, setShowFilters] = useState(false); // Control the visibility of filters
  const [filters, setFilters] = useState({
      service: null,
      service_category: null,
  });

  const handleFilterChange = (name, value) => {
    setFilterError('');
      setFilters((prevFilters) => ({
          ...prevFilters,
          [name]: value,
      }));
      setServiceErrorMessage('');
      // if(name=== 'service'){
      //   fetchTaskSubCategorieList(value?.value);
      // }
  };

  const applyFilters = () => {
      //console.log('Applying filters:', filters);
      if(!filters.service?.value){
        setServiceErrorMessage('Please Select Service');return
      }
      fetchTaskSubCategorieList(filters.service?.value);
  };

  const resetFilters = () => {
    if (filters?.service) {
      setCurrentPage(1);
      onRefresh();
    }
    setFilterError('');
    setSubError('');
    setServiceErrorMessage('');
    setFilters({
      service: null,
      service_category: null,
    });
  };

  const cancelFilters = () => {
    resetFilters();
    setShowFilters(!showFilters);
  }

  const toggleFilters = () => {
      setShowFilters(!showFilters);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  // var categoryList = subCategories;
  // if(subCategoriesList?.length > 0){
  //   categoryList = subCategoriesList
  // }else{
  //   categoryList = subCategories;
  // }
  const totalPages = Math.ceil(subCategoriesList?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTasks = subCategoriesList.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
  }
  };

  const maxVisiblePages = 3;

    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();


  return {
    subCategories,
    isModalOpen,
    handleAddCategory,
    handleCloseModal,
    getStatusStyle,
    handleEditService,
    categorieInfo,
    subCategoryInfoRef,
    OnAddUpdateSucess,
    handleDeleteTaskType,
    // loading,
    deleteLoading,
    deleteError,
    filterError,
    showFilters,
    filters,
    handleFilterChange,
    applyFilters, resetFilters, cancelFilters,
    toggleFilters,
    subCategoryListRef,
    subLoading,
    subError,
    tasks: currentTasks,
    currentPage,
    totalPages,
    handlePageChange,
    isDeleteModalOpen,
    handleCloseDeleteModal,
    callDeleteTaskType,
    deleteSuccess,
    serviceErrorMessage,
    visiblePages,
  };
};

export default useTaskTypeController;
